import Index from '@tunnel-components/@sharded/@widgets/scrollbars/container';

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/scrollbars/index.ts